import React, { useState } from 'react';
import { ShieldAlert } from 'lucide-react';
import { OwnerButton, OwnerCard, OwnerInfoList, OwnerShell } from '../OwnerShell';
import { CheckRow } from '../OwnerFields';
import { FlowSteps } from '../FlowSteps';
import { useOwnerService } from '../../../contexts/OwnerServiceContext';
import { ownerProfile } from '../../../data/ownerProfile';
import { toBn } from '../../../utils/bn';
import type { OwnerNav } from '../../../types/owner';
export function OwnerSelfVerify({
  nav
}: {
  nav: OwnerNav;
}) {
  const {
    submitApplication,
    ownerId
  } = useOwnerService();
  const [c, setC] = useState([false, false, false]);
  const d = nav.draft;
  const all = c.every(Boolean);
  const brtaResult = d.type === 'motorcycle' ? 'অনুপলব্ধ' : nav.brtaOutcome === 'matched' ? 'মিলেছে' : nav.brtaOutcome === 'mismatch' ? 'অমিল' : 'অনুপলব্ধ';
  const submit = () => {
    if (!all) return nav.showToast('তিনটি ঘোষণাই নিশ্চিত করুন');
    const id = submitApplication({
      ownerId,
      ownerName: ownerProfile.name,
      ownerMobile: ownerProfile.mobile,
      vehicleReg: d.reg,
      vehicleType: d.type,
      model: `${d.brand} ${d.model}`,
      chassis: d.chassis,
      engine: d.engine,
      brtaResult,
      docs: d.docs ?? 5,
      division: 'মিরপুর'
    });
    nav.setFocusAppId(id);
    nav.reset('submitted');
  };
  const toggle = (i: number) => (v: boolean) => setC(s => s.map((x, n) => n === i ? v : x));
  return <OwnerShell nav={nav} title="নিজের তথ্য নিশ্চিত করুন" subtitle="স্ব-যাচাই ঘোষণা" bodyClassName="p-0" footer={<OwnerButton variant="green" disabled={!all} onClick={submit} data-id="element-1957" data-mp="3j2j4vctgqe54">যাচাইয়ের জন্য আবেদন জমা দিন</OwnerButton>} data-id="element-1956" data-mp="3a3fm69y7k0r5">
      <FlowSteps current={4} data-id="element-1958" data-mp="3nt9b0s9pql0v" />
      <div className="space-y-3 px-4 py-4" data-id="element-1959" data-mp="3nukcumjllipc">
        <OwnerCard title="আবেদনের সারসংক্ষেপ" data-id="element-1960" data-mp="2rbd1mnig40bm">
          <OwnerInfoList rows={[['মালিকের নাম', ownerProfile.name], ['NID', ownerProfile.nid], ['মোবাইল', ownerProfile.mobile], ['গাড়ির ধরন', d.category], ['গাড়ির নম্বর', d.reg], ['চেসিস নম্বর', <span key="c" className="font-mono text-[12px]" data-id="element-1962" data-mp="3tnhqpfh66gvo">{d.chassis}</span>], ['ইঞ্জিন নম্বর', <span key="e" className="font-mono text-[12px]" data-id="element-1963" data-mp="c6zv02lpkz05">{d.engine}</span>], ['ডকুমেন্টের সংখ্যা', `${toBn(d.docs ?? 5)}টি`], ['BRTA যাচাই', brtaResult === 'মিলেছে' ? '✓ তথ্য মিলেছে' : brtaResult === 'অমিল' ? '! অমিল রয়েছে' : '○ ডিএমপি যাচাই করবে']]} data-id="element-1961" data-mp="2ralhq9y7nr16" />
        </OwnerCard>
        <div className="space-y-2" data-id="element-1964" data-mp="3arhu1rd8yp5r">
          <CheckRow checked={c[0]} onChange={toggle(0)} data-id="element-1965" data-mp="3opg3qjgmhxex">আমি এই গাড়ির বৈধ মালিক/অনুমোদিত প্রতিনিধি।</CheckRow>
          <CheckRow checked={c[1]} onChange={toggle(1)} data-id="element-1966" data-mp="3ko32kmoh6iec">প্রদত্ত তথ্য ও কাগজপত্র সঠিক।</CheckRow>
          <CheckRow checked={c[2]} onChange={toggle(2)} data-id="element-1967" data-mp="13yxjb8sp5s5o">প্রয়োজন হলে ডিএমপি কর্তৃপক্ষ তথ্য যাচাই করতে পারবে।</CheckRow>
        </div>
        <div className="flex gap-2.5 rounded-xl border border-blue-200 bg-blue-50 p-3 text-[12.5px] leading-relaxed text-blue-900" data-id="element-1968" data-mp="zwkh2ud5scdn">
          <ShieldAlert className="mt-0.5 h-5 w-5 shrink-0 text-blue-700" data-id="element-1969" data-mp="17j7qhp6uw86z" />
          “স্ব-যাচাই সম্পন্ন হলেও ডিএমপির অনুমোদন না পাওয়া পর্যন্ত গাড়িটি চূড়ান্তভাবে যাচাইকৃত হিসেবে গণ্য হবে না।”
        </div>
      </div>
    </OwnerShell>;
}